import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CostItemService, CostItemModel } from '../../services/index';

@Component({
  selector: 'cost-selector',
  templateUrl: 'cost-selector.html'
})
export class CostSelectorComponent {
  @Input() type: string;
  @Input() label: string;
  @Input() itemCd: string;
  @Input() itemNm: string;
  @Input() effect: boolean = false;
  @Output() onSelect: EventEmitter<CostItemModel> = new EventEmitter ();
  
  costItemList: CostItemModel[] = [];

  showDropDown: boolean = false;
  showAutoList: boolean = false;

  suggestList: Array<any> = [];

  linerControl: FormControl = new FormControl();

  focusedIndex: number = 0;
  selectedLine: CostItemModel = new CostItemModel();

  @ViewChild("suggestListRef")
  suggestListElRef: ElementRef;
  
  constructor(
    private costItemService: CostItemService
  ) {}

  ngOnInit() {
    this.costItemList = this.costItemService.costItemList;

    if(_.isEmpty(this.costItemList)) {
      this.costItemService.costItemEe.subscribe(
        costItemList => {
          this.costItemList  = costItemList;
        }
      );
    }
  }

  ngOnChanges() {
    if(this.itemCd != null && this.itemNm != null) {
      this.linerControl.setValue(this.itemNm);
    }
  }


  clickOutside() {
    if (this.showDropDown || (this.suggestList && this.suggestList.length > 0)) {
      this.clearLiner();
    } else {
      this.showDropDown =  false;
      this.showAutoList = false;
    }
  }

  clearLiner() {
    this.showDropDown = false;
    this.suggestList = [];
    this.focusedIndex =  0;
    this.selectedLine = new CostItemModel();
    this.onSelect.emit(null);
    this.linerControl.setValue(null);
  }

  handleSuggest(e) {
    let lineList = this.costItemList;
    let value = e.target.value;
    const inputValue = _.toUpper(value.trim()).replace(/\s/g, '');
    const inputLength = inputValue.length;

    let filteredList = [];
    let codeList = [];
    
    if (inputValue.length > 0) {
      codeList = _.filter(
        lineList,
        (line) => {
          return line.itemCd  === inputValue;
        }
      );

      filteredList = _.filter(lineList,
                                (line) => {
                                    let lineLabel = _.toUpper(line.itemNm).replace(/\s/g, '');
                                    return line.itemCd != inputValue && lineLabel.indexOf(inputValue) >= 0;
                                  }
                              );
      
      filteredList = _.sortBy(
        filteredList,
        (line) => {
          let lineLabel = _.toUpper(line.itemNm).replace(/:/g, 'AAAAAAAAAAA');
          return lineLabel;
        }
      );
      filteredList = _.sortBy(
        filteredList,
        (line) => {
          let lineLabel = _.toUpper(line.itemNm).replace(/\s/g, '');
          return _.toUpper(lineLabel).indexOf(inputValue);
        }
      );

      filteredList = codeList.concat(filteredList);
    }

    
    this.showDropDown = false;
    this.showAutoList = false;
    
    this.suggestList = filteredList;
    this.selectedLine = new CostItemModel();
    this.focusedIndex = 0;
    
  }

  handleKeyDown(event) {
    if (event.keyCode !== 9 && event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40) return;
    
    let focusedIndex = this.focusedIndex;
    let suggestListDom = null;
    if(this.suggestListElRef) suggestListDom = this.suggestListElRef.nativeElement;
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');

    let line = this.suggestList[this.focusedIndex];

		switch (event.keyCode) {
      case 9: //tab
        if (line) this.handleSelectLine(line);
        break;
			case 13: // enter
        if (line) this.handleSelectLine(line);
			  break;
			case 27: // escape
				this.clearLiner();
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > this.suggestList.length - 1) focusedIndex = this.suggestList.length - 1;
        if (focusedIndex != this.focusedIndex) this.focusedIndex = focusedIndex;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }
    if(event.keyCode != 9) {
      event.preventDefault();
    }
  }

  handleShowDropDown() {
    this.showDropDown = !this.showDropDown;
  }

  handleSelectLine(liner) {
    this.selectedLine = liner;

    let lineName = this.selectedLine.itemNm;
    this.linerControl.setValue(lineName);

    this.onSelect.emit(this.selectedLine);

    this.showDropDown = false;
    this.suggestList = [];
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/selector/cost-selector.ts